import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/images/footerLogo.svg";
import authenticationPageLogo from "../../assets/images/authenticationPageLogo.svg";
import { Form, Formik } from "formik";
import { signUpSchema } from "../../components/common/Validation";
import { signUpInitialValues } from "../../components/constants/InitialFormValues";
import CustomField from "../../components/common/CustomField";
import CustomLabel from "../../components/common/CustomLabel";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { resendVerificationLink, signUp } from "../../store/actions/authSlice";
import { showAlert } from "../../store/reducers/alertReducer";
import { getAllCountries } from "store/actions/citySlice";


import { da } from "date-fns/locale";
import CustomPhoneInput from "components/common/CustomPhoneInput";
import ButtonLoader from "components/common/ButtonLoader";

const SignUp = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isLoading, signUpUser } = useSelector((state) => state.auth);
  const { countries } = useSelector((state) => state.Cities);

  const [initialValues, setInitialValues] = useState(signUpInitialValues);
  const navigate = useNavigate();
  useEffect(() => {
    // GET CITY LIST
    const fetchCountryList = () => {
      dispatch(getAllCountries());
    };

    fetchCountryList();
  }, []);

  const [agreedTnc, setagreedTnc] = useState(false);

  const handleOnSubmit = (values) => {
    dispatch(signUp(values))
      .then((action) => {
        const { statusCode, success, message, data } = action?.payload || {};

        if (statusCode === 200 && success && data) {
          if (data.emailVerifiedAt == null) {
            try {
              dispatch(resendVerificationLink({ id: data._id })).then(
                (action) => {
                  const { statusCode, success, message, data } =
                    action?.payload || {};
                  if (statusCode === 200 && success && data) {
                    dispatch(
                      showAlert({
                        text: message,
                        type: "success",
                      })
                    );
                    navigate("/verification-status");
                  }
                }
              );
            } catch (err) {
              dispatch(
                showAlert({
                  type: "error",
                  text: "Something went wrong while sending verification email.",
                })
              );
              console.error("Resend verification link error:", err);
            }
          } else if (data.hasSubscriptionEntry === false) {
            navigate("/plan-picker");
          } else {
            navigate("/dashboard");
          }
        } else {
          dispatch(
            showAlert({
              type: "error",
              text: message || "Signup failed. Please try again.",
            })
          );
        }
      })
      .catch((err) => {
        dispatch(
          showAlert({
            type: "error",
            message: "Something went wrong during signup.",
          })
        );
        console.error("Error in signUp:", err);
      });
  };

  return (
    <div className="login_page">
      <div className="sign_up_page">
        <div className="login_form g_center">
          <div className="w-100">
            <img className="company_logo" src={authenticationPageLogo} width={180} height={96} alt="Work Space Logo" />
            <h1>{t("Sign Up")}</h1>
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={signUpSchema}
              onSubmit={handleOnSubmit}
            >
              {({ values, setFieldValue, errors, touched, submitCount }) => (
                <Form>
                  <div className="form_field">
                    <CustomLabel htmlFor="name" label={t("Name")} />
                    <CustomField
                      name="name"
                      type="text"
                      placeholder={t("Email your name")}
                      touched={touched}
                      errors={errors}
                    />
                  </div>
                  <div className="form_field">
                    <CustomLabel htmlFor="email" label={t("Email")} />
                    <CustomField
                      name="email"
                      type="email"
                      placeholder={t("Email your email")}
                      touched={touched}
                      errors={errors}
                    />
                  </div>
                  <div className="form_field">
                    <CustomPhoneInput
                      initialPhoneCode={values.phoneCode}
                      initialPhoneNumber={values.phoneNumber}
                      onChange={({ phoneNumber, countryCode }) => {
                        setFieldValue("phoneNumber", phoneNumber);
                        setFieldValue("phoneCode", countryCode);
                      }}
                    />
                  </div>

                  <div className="form_field">
                    <CustomLabel htmlFor="password" label={t("Password")} />
                    <CustomField
                      name="password"
                      type="password"
                      placeholder={t("Enter your password")}
                      touched={touched}
                      errors={errors}
                    />
                  </div>
                  <div className="remember_div">
                    <div className="c_p">
                      <input
                        type="checkbox"
                        name="hasAgreedTnC"
                        className="form-check-input c_p"
                        id="customControlInline"
                        checked={values.hasAgreedTnC}
                        onChange={(e) =>
                          setFieldValue("hasAgreedTnC", e.target.checked)
                        }
                      />
                      <label
                        className="form-check-label remember_me c_p"
                        htmlFor="customControlInline"
                      >
                        {t("I accept the Terms and Conditions")}
                      </label>
                      {errors.hasAgreedTnC && (
                        <div className="text-danger">{errors.hasAgreedTnC}</div>
                      )}
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="primary_btn w-100 g_center gap-2"
                    disabled={isLoading}
                  >
                    {t("Sign up")}
                    {
                      isLoading &&
                      <ButtonLoader/>
                    }
                  </button>
                </Form>
              )}
            </Formik>
            <div className="text-center sign_up_link_wrapper">
              <p>Or </p>
              <Link to="/" className="sign_up_link">
                Log in
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
